import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../../common'

// NOTE: this file might be moved into some shared location in the future, just
// because SPACE application uses the same stuff.

const DOC = gql`
  query FaFunctionCategoryWithSubcategories(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              faFunctionCategories {
                category {
                  id
                  code
                  name
                  type
                }
                subcategories {
                  id
                  code
                  name
                  isUtilityRelated
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.FaFunctionCategoryWithSubcategoriesQuery,
    ents.extra.common.FaFunction.Category.WithSubcategories[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'faFunctionCategories',
              graphql.transformers.OUT.list(
                graphql.transformers.OUT.object({
                  code: {
                    usingFullInput: graphql.transformers.OUT.nonNull(
                      graphql.transformers.OUT.select(
                        'category',
                        graphql.transformers.OUT.select(
                          'code',
                          transformers.PASS_THROUGH,
                        ),
                      ),
                      { warnOnly: true },
                    ),
                  },
                  id: {
                    usingFullInput: graphql.transformers.OUT.nonNull(
                      graphql.transformers.OUT.select(
                        'category',
                        graphql.transformers.OUT.select(
                          'id',
                          graphql.transformers.OUT.validate(
                            transformers.PASS_THROUGH,
                            ents.extra.common.FaFunction.Category.Id.isId,
                            { warnOnly: true },
                          ),
                        ),
                      ),
                      { warnOnly: true },
                    ),
                  },
                  name: {
                    usingFullInput: graphql.transformers.OUT.nonNull(
                      graphql.transformers.OUT.select(
                        'category',
                        graphql.transformers.OUT.select(
                          'name',
                          transformers.PASS_THROUGH,
                        ),
                      ),
                      { warnOnly: true },
                    ),
                  },
                  subcategories: graphql.transformers.OUT.default(
                    graphql.transformers.OUT.list(
                      graphql.transformers.OUT.object({
                        code: graphql.transformers.OUT.validate(
                          transformers.PASS_THROUGH,
                          TypeChecker.isNotNullish,
                          { warnOnly: true },
                        ),
                        id: graphql.transformers.OUT.validate(
                          transformers.PASS_THROUGH,
                          ents.extra.common.FaFunction.Subcategory.Id.isId,
                          { warnOnly: true },
                        ),
                        // NOTE: by default isUtilityRelated will be false
                        isUtilityRelated: graphql.transformers.OUT.default(
                          transformers.PASS_THROUGH,
                          false,
                        ),
                        name: graphql.transformers.OUT.validate(
                          transformers.PASS_THROUGH,
                          TypeChecker.isNotNullish,
                          { warnOnly: true },
                        ),
                      }),
                      { onNullish: 'remove' },
                    ),
                    [],
                  ),
                  type: {
                    usingFullInput: graphql.transformers.OUT.nonNull(
                      graphql.transformers.OUT.select(
                        'category',
                        graphql.transformers.OUT.select(
                          'type',
                          common.gql.faFunctions.enums.type.TRANSFORMER,
                        ),
                      ),
                      { warnOnly: true },
                    ),
                  },
                }),
                {
                  onNullish: 'remove',
                },
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.FaFunctionCategoryWithSubcategoriesQuery,
  ents.extra.common.FaFunction.Category.WithSubcategories[],
  graphql.schema.FaFunctionCategoryWithSubcategoriesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
